/* SteinKunstWerk: cart bridge disabled during Web SDK migration.
 * Canonical cart events remain with Shopify Customer Events/PixieHog until migration cutover.
 * During an explicit migration test, seed the top-frame localStorage key that
 * Shopify Custom Pixels can read asynchronously through browser.localStorage.
 */
(function () {
  'use strict';

  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get('skw_ph_test') === '1') {
      window.localStorage.setItem(
        'skw_ph_migration_test_until',
        String(Date.now() + (2 * 60 * 60 * 1000))
      );
      window.__SKW_POSTHOG_MIGRATION_TEST__ = true;
    }
  } catch (e) {}
})();
